import { useThresholds } from '../hooks/trThresholds';

export default function Thresholds({ embedded = false }) {
  const { defaults, draft, loading, saving, dirty, handleChange, handleSave, handleReset, GROUPS } = useThresholds();

  const wrapper = embedded ? '' : 'p-6';

  if (loading || !draft) {
    return (
      <div className={wrapper}>
        <div className="animate-pulse space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-24 bg-gray-100 rounded-lg" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={wrapper}>
      {!embedded && (
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Seuils d'alerte</h1>
          <p className="text-sm text-gray-500 mt-1">Personnalisez les seuils GPS et timing pour votre école.</p>
        </div>
      )}

      <div className="space-y-6">
        {GROUPS.map((group) => (
          <div key={group.id} className="bg-white rounded-xl border border-gray-200 p-5">
            <h2 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-4">{group.label}</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {group.fields.map((field) => {
                const currentVal = draft[field.key] ?? '';
                const defaultVal = defaults?.[field.key];
                const isModified = defaultVal !== undefined && Number(currentVal) !== defaultVal;
                const isAtBound =
                  currentVal !== '' && (Number(currentVal) === field.min || Number(currentVal) === field.max);
                return (
                  <div key={field.key}>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {field.label}
                      {isModified && (
                        <span className="ml-2 text-xs text-amber-600 font-normal">
                          (défaut : {defaultVal} {field.unit})
                        </span>
                      )}
                    </label>
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        min={field.min}
                        max={field.max}
                        value={currentVal}
                        onChange={(e) => handleChange(field.key, Number(e.target.value))}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <span className="text-xs text-gray-400 whitespace-nowrap">{field.unit}</span>
                    </div>
                    {field.help && <p className="text-xs text-gray-500 mt-1">{field.help}</p>}
                    {isAtBound && (
                      <p className="text-xs text-amber-600 mt-1">
                        ⚠️ Valeur à la limite autorisée — vérifiez que c'est intentionnel.
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mt-6">
        <button onClick={handleReset} className="text-sm text-gray-500 hover:text-gray-700 underline">
          Réinitialiser aux valeurs par défaut
        </button>
        <button
          onClick={handleSave}
          disabled={!dirty || saving}
          className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </button>
      </div>
    </div>
  );
}
